<script lang="ts" setup>
import { useTenantImage } from "~/queries/userSettings"

const { height = 32, maxWidth = undefined, tenantImage = undefined } = defineProps<{
	height?: number
	maxWidth?: number
	tenantImage?: string
}>()

const { data } = useTenantImage()
const cacheBuster = ref(Date.now())

watch(data, () => {
	cacheBuster.value = Date.now()
})

// data is guaranteed non-empty by the v-if on the root template element.
const imagePath = computed(() =>
	`/api/images/get/${tenantImage ?? data.value}?t=${cacheBuster.value}`
)
</script>

<template>
	<div v-if="data != null && data !== ''" class="flex gap-x-4">
		<slot name="prepend" />
		<div class="self-center">
			<img class="object-contain"
				:style="{ height: height + 'px', maxWidth: maxWidth != null ? maxWidth + 'px' : undefined }"
				:src="imagePath">
		</div>
	</div>
</template>

<style></style>
